import React from 'react';
import { Badge } from "react-bootstrap";
import { addWeeks } from 'date-fns';
import moment from 'moment';
import { Dropdown } from "react-bootstrap";
import ActionDropdownToggle from "../CustomDropdowns/ActionDropdownToggle";
import { completeActionConfirmationDialog } from "../../../pages/admin/Contracts/Contract/ContractActions";
import * as actionCrud from "../../../crud/action.crud";
import { injectIntl } from "react-intl";
import { withSnackbar } from 'notistack';
import { withRouter } from '../../../shared/hoc/withRouter';
import MenuItemsHelper from "../../../store/helpers/MenuItemsHelper";



const getNotificationDate = (actionItem) => {
    let actionDate = null;
    if (actionItem.type === "DRAFT") {
        actionDate = new Date(actionItem.createdate);
    }
    else {
        actionDate = new Date(actionItem.duedate);
    }
    if (actionDate) {
        let badgeVariant = MenuItemsHelper.getBadgeColorForRAGColor(actionItem.RAGColor, "bootstrap");
        return (<Badge variant={badgeVariant}>{moment(actionDate).format('L')}</Badge>)
    } else {
        return null;
    }
}

class PendingActionItemRow extends React.Component {
    constructor(props) {
        super(props);
        const initialState = this.getActionsState();
        this.state = {
            ...initialState
        }
    }

    getActionsState = () => {
        const { actionItem, workflow } = this.props;
        const actionOptions = []
        let noActions = false;
        if (actionItem.groupcategory === 0 && !actionItem.parentrecordid && (workflow?.userFilters?.mainNotice?.viewDraftAllowed)) {
            actionOptions.push({ icon: "flaticon2-paper", text: `View ${workflow.title}`, onClick: this.onClickDestination });
        }
        if (actionItem.groupcategory === 0 && actionItem.parentrecordid && (workflow?.userFilters?.quoteMainNotice?.createQuoteAllowed || workflow?.userFilters?.quoteMainNotice?.communicateQuoteAllowed)) {
            actionOptions.push({ icon: "flaticon2-paper", text: `View ${workflow.title}`, onClick: this.onClickDestination });
        }
        if (actionItem.groupcategory === 1) {
            actionOptions.push({ icon: "flaticon2-check-mark", text: `Set Complete`, onClick: this.onClickComplete });
        }
        if ([1, 3].includes(actionItem.groupcategory) && actionItem.sourcereferenceid && actionItem.sourceworkflowid && actionItem.sourcerecordid) {
            actionOptions.push({ icon: "flaticon2-paper", text: `View Related ${actionItem.sourcereferenceid}`, onClick: this.onClickSource });
        }
        if (actionItem.groupcategory === 3 && workflow?.userFilters?.mainNotice?.createAllowed) {
            actionOptions.push({ icon: "flaticon2-add-square", text: `Create ${workflow.title}`, onClick: this.onClickDestination });
        }
        if (actionItem.groupcategory === 2) {
            if (workflow?.userFilters?.replyNotice?.saveDraftReplyAllowed || workflow?.userFilters?.replyNotice?.communicateReplyAllowed) {
                actionOptions.push({ icon: "flaticon2-reply", text: `Reply ${workflow.title}`, onClick: this.onClickDestination });

            }
            else {
                actionOptions.push({ icon: "flaticon2-paper", text: `View ${workflow.title}`, onClick: this.onClickDestination });
            }
        }
        if (actionItem.groupcategory === 4) {
            if (workflow?.userFilters?.quoteMainNotice?.createQuoteAllowed) {
                actionOptions.push({ icon: "flaticon2-add-square", text: `Create ${workflow.title}`, onClick: this.onClickDestination });
            }
            else {
                actionOptions.push({ icon: "flaticon2-paper", text: `View ${workflow.title}`, onClick: this.onClickDestination });
            }
        }
        if (actionItem.groupcategory === 5) {
            if (workflow?.userFilters?.quoteReplyNotice?.saveQuoteDraftReplyAllowed || workflow?.userFilters?.quoteReplyNotice?.communicateQuoteReplyAllowed) {
                actionOptions.push({ icon: "flaticon2-reply", text: `Reply ${workflow.title}`, onClick: this.onClickDestination });
            }
            else {
                actionOptions.push({ icon: "flaticon2-paper", text: `View ${workflow.title}`, onClick: this.onClickDestination });
            }
        }
        if (actionItem.groupcategory === 6) {
            if (workflow?.userFilters?.actionTab?.actionAllowed || workflow?.userFilters?.actionTab?.resolveActionAllowed) {
                actionOptions.push({ icon: "flaticon2-accept", text: `Action ${workflow.title}`, onClick: this.onClickDestination });

            }
            else {
                actionOptions.push({ icon: "flaticon2-paper", text: `View ${workflow.title}`, onClick: this.onClickDestination });
            }
        }
        if (actionOptions.length === 0) {
            noActions = true;
            actionOptions.push({ icon: "flaticon2-cross", text: `No actions available`, onClick: this.onEmptyClick, style: { cursor: "default" } });
        }
        const toggleClickAction = {}
        if (actionOptions.length === 1 && !noActions && actionItem.groupcategory !== 1) {
            //IF GROUP CATEGORY IS NOT 1
            //AND IF THERE IS ONLY ONE ACTION OPTION
            //DIRECTLY EXECUTE ACTION
            //THERE IS NO NEED TO SHOW 1 ITEM DROPDOWN OPTION
            toggleClickAction.onClick = actionOptions[0].onClick;
        }
        return {
            actionOptions,
            toggleClickAction
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.actionItem !== nextProps.actionItem || this.props.workflow !== nextProps.workflow) {
            return true;
        }
        return false;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps) {
            if (prevProps.actionItem !== this.props.actionItem || prevProps.workflow !== this.props.workflow) {
                const newState = this.getActionsState();
                this.setState({ ...newState })
            }
        }
    }
    onEmptyClick = (e) => {
        e.preventDefault();
    }
    onClickComplete = async (e) => {
        e.preventDefault();
        const { actionItem, workflow } = this.props;
        let result = await completeActionConfirmationDialog(actionItem, this.props.intl);
        if (result) {
            try {
                const requestObj = {
                    contractid: this.props.contract.contractid,
                    actionids: [actionItem.actionid]
                }
                const response = await actionCrud.complete(requestObj);
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.ACTION_COMPLETED" }), { variant: "success" });
            } catch (err) {
                this.props.enqueueSnackbar(err.toString(), { variant: "error" });
            }
        }
    }
    onClickSource = (e) => {
        e.preventDefault();
        const { actionItem, contractTemplate } = this.props;
        if (contractTemplate.workflowsQA[actionItem.sourceworkflowid]) {
            if (this.props.panelCloseBtnRef) {
                this.props.panelCloseBtnRef.current.click();
            }
            this.props.navigate(contractTemplate.workflowsQA[actionItem.sourceworkflowid].paths.basePath + actionItem.sourcerecordid);
        }
    }
    onClickDestination = (e) => {
        e.preventDefault();
        const { actionItem, workflow } = this.props;
        if (workflow) {
            const relationState = {};
            if (actionItem.sourceworkflowid && actionItem.sourcerecordid) {
                const sourceWF = this.props.contractTemplate.workflowsQA[actionItem.sourceworkflowid];
                relationState.state = {
                    itemBaseProps: {
                        wfid: sourceWF.id,
                        wfgid: sourceWF.groupID,
                        reftype: sourceWF.config.referenceType,
                        path: sourceWF.paths.basePath + actionItem.sourcerecordid,
                        refid: actionItem.sourcerecordid,
                    },
                    itemCustomProps: {
                        subject: actionItem.subject,
                    }
                }
            }

            if (this.props.panelCloseBtnRef) {
                this.props.panelCloseBtnRef.current.click();
            }
            if (actionItem.type === "SYSTEM_COMMUNICATE_QUOTE") {
                let quoteCreatePath = '';
                if (workflow?.userFilters?.quoteMainNotice?.createQuoteAllowed) {
                    quoteCreatePath = workflow.paths.quotationBasePath.replace(":notificationid", actionItem.resolvingrecordid) + "create";
                }
                else {
                    quoteCreatePath = workflow.paths.basePath + actionItem.resolvingrecordid;

                }
                this.props.navigate(quoteCreatePath);
            }
            else if (actionItem.type === "SYSTEM_REPLY_QUOTE") {
                const quoteReplyPath = workflow.paths.quotationBasePath.replace(":notificationid", actionItem.resolvingrecordid) + actionItem.resolvingchildrecordid;
                this.props.navigate(quoteReplyPath);
            }
            else if (actionItem.type === "DRAFT" && actionItem.recordid && actionItem.parentrecordid) {
                const quoteDraftPath = workflow.paths.quotationBasePath.replace(":notificationid", actionItem.parentrecordid) + actionItem.recordid;
                this.props.navigate(quoteDraftPath);
            }
            else if (actionItem.type === "DRAFT" && actionItem.recordid && !actionItem.parentrecordid) {
                this.props.navigate(workflow.paths.basePath + actionItem.recordid);
            }
            else if (actionItem.resolvingrecordid) {
                this.props.navigate(workflow.paths.basePath + actionItem.resolvingrecordid);
            }
            else {
                this.props.navigate(workflow.paths.createPath, relationState);
            }
        }
    }

    render() {
        return (
            <Dropdown
                key={this.props.skey + "-DDN"}
                // className="kt-header__topbar-item kt-header__topbar-item--langs"
                drop="down"
            >
                <Dropdown.Toggle
                    {...this.state.toggleClickAction}
                    key={this.props.skey + "-DDNT"}
                    as={ActionDropdownToggle}
                    id="dropdown-toggle-action">
                    <div style={{ width: '100%', float: 'right', display: 'flex', flexDirection: 'row-reverse' }}>
                        <div>{getNotificationDate(this.props.actionItem)}</div>
                        <div style={{
                            width: '100%',
                            fontWeight: 400,
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            boxOrient: 'vertical',
                            overflow: 'hidden',
                            marginLeft: 5,
                        }}>
                            {this.props.actionItem.sourcereferenceid && (<strong style={{ marginRight: 5 }}>{this.props.actionItem.sourcereferenceid}</strong>)}
                            {this.props.actionItem.type === "DRAFT" && this.props.actionItem.parentrecordid ? '[QUOTE] ' : ''}{this.props.actionItem.subject}
                        </div>
                    </div>
                </Dropdown.Toggle>
                {(!this.state.toggleClickAction.onClick) && (
                    <Dropdown.Menu
                        key={this.props.skey + "-DDNM"}
                        className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-lg" >
                        <ul className="kt-nav">
                            {
                                this.state.actionOptions.map((opt, index) => (
                                    <li style={opt.style ? { ...opt.style } : null} className="kt-nav__item" key={`PendingActionSelector_${index}`} >
                                        <a style={opt.style ? { ...opt.style } : null} href="#" className="kt-nav__link">
                                            <i className={`kt-nav__link-icon ${opt.icon}`} />
                                            <span id={`PendingActionSelector_${index}`} className="kt-nav__link-text" onClick={opt.onClick}>{opt.text}</span>
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                    </Dropdown.Menu>
                )}

            </Dropdown>

        );
    }

};

export default withRouter(withSnackbar(injectIntl(PendingActionItemRow)));